import { useAuth } from '@hourly/contexts/AuthContext';
import { Tab, Tabs } from '@hourly-hds/components';
import { TabProps } from '@hourly-hds/components/dist/Tabs/Tab';
import { useNavigate, useParams } from 'react-router';
import Page from '../../_layout/components/Page';
import BankAccount from './components/BankAccount';
import Documents from './components/Documents';
import PartnerInformation from './components/PartnerInformation';
import UsersIndex from './components/users';

import styles from './Settings.view.module.css';

export default function SettingsActiveTab() {
  const { activeTab } = useParams();
  const { sessionState } = useAuth();
  const navigate = useNavigate();
  const partnerId = sessionState.partnerId ?? '';

  const tabItems: TabProps[] = [
    {
      value: 'partner-information',
      label: 'Partner Information',
    },
    {
      value: 'users',
      label: 'Users',
    },
    {
      value: 'bank-account',
      label: 'Bank Account',
    },
    {
      value: 'documents',
      label: 'Documents',
    },
  ];

  return (
    <Page>
      <Page.Header>
        <Page.Title>Settings</Page.Title>
      </Page.Header>
      <Page.Content>
        <Tabs onChange={(value) => navigate(`/settings/${value}`)} value={activeTab!}>
          {tabItems.map((item) => (
            <Tab key={item.value} value={item.value} label={item.label} />
          ))}
        </Tabs>

        <div className={styles.settingsContent}>
          {activeTab === 'partner-information' && <PartnerInformation partnerId={partnerId} />}
          {activeTab === 'bank-account' && <BankAccount partnerId={partnerId} />}
          {activeTab === 'users' && <UsersIndex partnerId={partnerId} />}
          {activeTab === 'documents' && <Documents partnerId={partnerId} />}
        </div>
      </Page.Content>
    </Page>
  );
}
